import React from "react";
import { motion } from "framer-motion";

const HowItWorks = () => {
  const steps = [
    {
      icon: <i className="fas fa-search"></i>,
      title: "Choose Your Category",
      description:
        "Select the category that interests you from our wide range of courses.",
    },
    {
      icon: <i className="fas fa-list-alt"></i>,
      title: "Select Your Course",
      description:
        "Pick the course you want to enroll in and view all the details.",
    },
    {
      icon: <i className="fas fa-calendar-alt"></i>,
      title: "Schedule Your Session",
      description:
        "Choose the date and time that suits you, along with the teacher assigned to the course.",
    },
    {
      icon: <i className="fas fa-credit-card"></i>,
      title: "Make Payment",
      description: "Pay securely using Stripe or locally via CBE account.",
    },
    {
      icon: <i className="fas fa-check-circle"></i>,
      title: "Approval & Notification",
      description:
        "Admin reviews your application and notifies you once approved for the live session.",
    },
    {
      icon: <i className="fas fa-video"></i>,
      title: "Join Live Session",
      description:
        "Access the live session at the scheduled time and interact with the teacher and other students.",
    },
  ];

  return (
    <div className="pb-12">
      <div className="container mx-auto">
        <div className="px-10">
          <h1 className="text-xl sm:text-2xl font-bold text-center mb-10 text-gray-800 border border-gray-800 rounded-2xl py-3">
            How It Works
          </h1>
        </div>
        <div className="space-y-8 px-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start space-x-4 p-4 bg-white rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
            >
              <div className="text-4xl text-blue-500">{step.icon}</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
